import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import InsightsPage from './InsightsPage';

const InsightsRoutes: React.FC = () => {
    const { path } = useRouteMatch();

    console.log('InsightsRoutes path', path);
    return (
        <>
            <Switch>
                <Route exact path={`${path}`} component={InsightsPage} />
            </Switch>
        </>
    );
};

export default InsightsRoutes;
